module.exports = __webpack_public_path__ + "img/header1.c05cbf5f.png";